import { render, staticRenderFns } from "./HeartLike.vue?vue&type=template&id=2a83b8e8&scoped=true&"
import script from "./HeartLike.vue?vue&type=script&lang=js&"
export * from "./HeartLike.vue?vue&type=script&lang=js&"
import style0 from "./HeartLike.vue?vue&type=style&index=0&id=2a83b8e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a83b8e8",
  null
  
)

export default component.exports